export default window._cmsContent['layout/footer']